import "./templates/style.less";

class ITState extends Backbone.Model {
}

ITState.prototype.defaults = {
    spec: "",
    manifestSpec: "",
    autoInitialize: true,
    autoPlay: true,
    tickDelay: 0,
    scriptView: "lines",
    scriptState: "pending",
    chromeType: "primary",
    showTargets: false,
    // previously anonymous attributes
    scriptMode: null,
    script: null,
    interpreter: null,
};

export default ITState;



// WEBPACK FOOTER //
// ./test/it/lib/ITState.js